<div class="{{ isCompareSelected ? 'border-box' : 'no-border-box' }}">
  <mat-card (click)="route()" class="projectcard" [style.height]="cardHeight" *ngIf="!newProject">
    <usimweb-request-bar [cardItem]="cardItem" *ngIf="isSupport"></usimweb-request-bar>
    <p class="projectcard-modelname" *ngIf="modelname">{{ modelname }}</p>

    <!-- <p style="font-size: 14px; margin-left: 15px" *ngIf="owner">{{ projectName }}</p>
  <p style="font-size: 14px; margin-left: 15px" *ngIf="!owner">
    {{ projectName }}
  </p> -->

    <div>
      <div *ngIf="loading; else showImage">
        <!-- <usimweb-loader [size]="60" [enabled]="loading"></usimweb-loader> -->
      </div>
      <ng-template #showImage>
        <picture style="position: absolute; left: 50%; top: 42%; transform: translate(-50%, -50%)">
          <div *ngIf="stonChipConfig; else prevImg">
            <div *ngIf="stonChipConfig.loadcase.projectileType == 'multi'">
              <mat-icon class="projectcard-aniImg">grain</mat-icon>
            </div>

            <div *ngIf="stonChipConfig.loadcase.projectileType == 'sphere'">
              <mat-icon class="projectcard-aniImg">brightness_1</mat-icon>
            </div>
            <div style="transform: rotate(90deg)" *ngIf="stonChipConfig.loadcase.projectileType == 'sharpedge'">
              <mat-icon class="projectcard-aniImgX">play_arrow</mat-icon>
            </div>
          </div>

          <ng-template #prevImg>
            <!-- <source  width="125" height="125" sizes="(min-width: calc(77.875em * 100/78.48)) calc(80em - 2.125em), (min-width: 30em) 78.48vw,  90.6vw" [srcset]="preview">   -->
            <img style="max-height: 180px; max-width: 250px" *ngIf="preview" [attr.src]="preview" alt="no project preview" />
            <div style="position: absolute" *ngIf="heatLossW" class="titleWattImage">{{ heatLossW | number : '1.0-0' }} W</div>
            <div style="position: absolute" *ngIf="volume" class="tileLitreImage">{{ volume * 1000 | number : '1.0-0' }} l</div>
          </ng-template>
        </picture>

        <img
          *ngIf="!preview"
          style="position: absolute; left: 50%; top: 42%; transform: translate(-50%, -50%)"
          src="assets/img/image_no_support.png"
          width="80px"
          height="80px"
          alt="image_no_support" />
      </ng-template>
    </div>

    <mat-card-content style="padding: 0">
      <div class="row" [style.position]="'absolute'" [style.width]="'100%'" [style.bottom]="descriptionMargin" [style.margin-left]="'10px'">
        <div class="col-1 text-right">
          <span class="dot"></span>
        </div>
        <div class="col-10 p-0">
          <p [tooltip]="projectName" class="{{ isMeshing === true ? 'projectcard-project-name-meshing' : 'projectcard-project-name' }}">
            {{ projectName }}
          </p>
        </div>

        <!-- <div class="col-3" *ngIf="!isProjectCard && !isMeshing" style="text-align: right; height: 0px">
        <mat-icon
          *ngIf="progress === 0 && versionStatus.overall !== 'failed'"
          tooltip="Not starting yet... (in queue)"
          class="icon"
          >access_time</mat-icon
        >

        <mat-icon
          *ngIf="progress >= 1 && progress <= 99 && versionStatus.overall !== 'failed'"
          tooltip="Remaining time:  {{ estimatedTime }} ({{ progress }}%)"
          class="icon">
          access_time
        </mat-icon>

        <mat-icon *ngIf="versionStatus.overall === 'failed'" tooltip="Simulation failed!" class="icon"
          >report_problem</mat-icon
        >
      </div>

      <p style="color: #b7b7b7; font-size: 10px; margin-top: 5px; margin-left: 22px; margin-bottom: 12px">
        {{ created_at }}
      </p> -->
      </div>

      <usimweb-card-bar
        *ngIf="showBar"
        [user]="user"
        [project]="project"
        (openDialog)="openDialog($event)"
        (click)="$event.stopPropagation()"
        (updateSupportedEvent)="updateSupported($event)"
        (favouriteEventChanged)="favouriteChanged($event)"></usimweb-card-bar>

      <usimweb-status-bar
        *ngIf="!isMeshing"
        [versionStatus]="versionStatus"
        [projectStatus]="projectStatus"
        [top]="false"
        [progress]="versionStatus.progress"
        [multiple]="multipleStatusBar"></usimweb-status-bar>
    </mat-card-content>

    <usimweb-menu
      (click)="$event.stopPropagation()"
      *ngIf="!showBar"
      [menuItems]="menuItems"
      [uuid]="uuid"
      (eventEmitterItemClicked)="menuItemClicked($any($event))"
      style="position: absolute; bottom: 5px; right: 8px"></usimweb-menu>
  </mat-card>

  <mat-card (click)="newItemClicked(newItemLink)" class="projectcard" style="background-color: white !important" *ngIf="newProject">
    <mat-icon class="add_icon" color="black">add</mat-icon>
    <div class="projectcard-text mt-1">
      <p>{{ newCardTitle }}</p>
    </div>
  </mat-card>
</div>
